import PadelyfeLogo from "src/assets/images/padelyfe_logo.png";

export const appAsset = {
  appName: "Padelyfe",
  appLogo1: PadelyfeLogo,
  appLogo2: undefined as any,
  appTabIconHref: "/favicon.ico",
  appleTouchIconLinkHref: "/appleTouchIcon.png",
  bankName: "Cynthia Angelina",
  bankAccount: "BCA 0888 000 677",
  contact: {
    emails: ["padelyfe@gmail.com"],
    instagrams: ["padelyfe.store"],
    phone: "+62 8883 328 888",
  },
};